<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-12-04 16:44:57
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-07 16:05:30
 * @FilePath: \miniproweb\src\views\QueryStatistics\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="queryBody">
    <div class="typeChooseBox" @click="changeType">
      <div data-index="气温" class="typeChooseBoxItem actve" @click="changeType">气温</div>
      <div data-index="降水" class="typeChooseBoxItem" @click="changeType">降水</div>
      <div data-index="湿度" class="typeChooseBoxItem" @click="changeType">湿度</div>
      <div data-index="风速" class="typeChooseBoxItem" @click="changeType">风速</div>
    </div>
    <div class="mapBox2" id="map2"></div>

    <div class="tableBox">
      <el-table :data="tableData" height="350" border>
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="stationName" label="站点"></el-table-column>
        <el-table-column :prop="valueType" :label="chooseType">
          <template slot-scope="scope">
            <div>{{dataHanderller(scope.row[valueType])}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="趋势">
          <template slot-scope="scope">下降</template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="gotoPage(scope.row,valueType)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../../map/mapImport.js";
export default {
  data() {
    return {
      map: null,
      tableData: [],
      chooseType: "温度",
      valueType: "temAvg"
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("map2");
  },
  methods: {
    dataHanderller(data) {
      if (data == 999999) {
        return "/";
      } else {
        return data;
      }
    },
    gotoPage(e, data) {
      console.log(e, data);
      this.$router.push({
        name: "Echart",
        params: {
          sta: e.stationNum,
          type: data
        }
      });
    },
    changeType(e) {
      const DomElList = document.querySelectorAll(".typeChooseBoxItem");
      DomElList.forEach(item => {
        // console.log(item);
        item.classList.remove("actve");
      });
      e.target.classList.add("actve");
      console.log(e.target.dataset);
      this.chooseType = e.target.dataset.index;
      if (this.chooseType == "温度") {
        this.valueType = "temAvg";
      } else if (this.chooseType == "降水") {
        this.valueType = "pre1h";
      } else if (this.chooseType == "湿度") {
        this.valueType = "rhuAvg";
      } else if (this.chooseType == "风速") {
        this.valueType = "winSMax";
      }
    },
    getData() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/HourDataService/hourDataImageTest?datetime=2023-11-09 14:00:00`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.tableData = res.data.data;
      });
    }
  }
};
</script>

<style>
.queryBody {
  height: 100vh;
  width: 100vw;
  background-color: #111b2e;
}
.mapBox2 {
  width: 100%;
  height: 350px;
  background-color: aliceblue;
  /* position: absolute;
  top: 50px; */
}
.typeChooseBox {
  height: 50px;
  width: 100%;
  background-color: #233c7a;
  /* position: fixed;
  top: 0px;
  z-index: 9999; */
  display: flex;
}
.typeChooseBoxItem {
  width: 25%;
  height: 100%;
  text-align: center;
  line-height: 50px;
  color: white;
}
.actve {
  color: #42a0fd;
}
.tableBox {
  height: 300px;
  width: 100%;
}
</style>